import { Chip, Stack, Typography } from "@mui/material";

import { UserDetailIcon } from "../../components";
import { stringToAlphabetSum } from "../../helpers/userImageColor";
import { getDollarValue } from "../../helpers/currency";

export const items = [
  { id: "name", label: "Customer", sortable: true },
  { id: "contact", label: "Primary Contact" },
  { id: "address", label: "Main Address" },
  { id: "phone", label: "Phone Number" },
  { id: "active", label: "Status" },
  { id: "revenue", label: "Total Revenue", sortable: true },
  { id: "location", label: "Foundry", sortable: true },
];

export const keys = [
  {
    value: "name",
    CustomComponent: ({ item }) => (
      <Typography variant="boldCaptionL" fontSize={11}>
        {item?.name || "—"}
      </Typography>
    ),
  },
  {
    value: "contact",
    CustomComponent: ({ item }) => {
      const contact = item?.contact || {};
      const { name = "", email = "" } = contact;
      return name || email ? (
        <UserDetailIcon
          user={{
            name,
            email,
            hueShift: stringToAlphabetSum(
              email && name ? email + name : name || email,
            ),
          }}
          // includeThumbnail={false}
          includeEmail={email}
          includeName={name}
          // includeInital
          size={18}
        />
      ) : (
        <Typography variant="caption" fontSize={10} color="text.disabled">
          —
        </Typography>
      );
    },
  },
  { value: "address", defaultValue: "—" },
  {
    value: "phone",
    CustomComponent: ({ item }) => (
      <Typography variant="caption" fontSize={11}>
        {item?.contact?.phone || "—"}
      </Typography>
    ),
  },
  {
    value: "active",
    CustomComponent: ({ item }) => (
      <Chip
        variant="colorTag"
        flow={item?.active ? "green" : "grey"}
        label={`${item?.active ? "Active" : "Inactive"}`}
        size="small"
        sx={{ fontSize: 10, fontWeight: 600 }}
      />
    ),
  },
  {
    value: "totalSpent",
    CustomComponent: ({ item }) => (
      <Typography variant="caption" fontSize={11}>
        {getDollarValue(item?.totalSpent)}
      </Typography>
    ),
  },
  {
    value: "locations",
    CustomComponent: ({ item }) => (
      <Stack direction="row" gap="3px" flexWrap="wrap">
        {item?.locations?.map((l) => (
          <Chip
            key={l?.id}
            label={l?.name}
            size="small"
            sx={{ fontSize: 10, height: 20 }}
          />
        ))}
      </Stack>
    ),
  },
];
